import { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import Share from './Share/Share';
import PreviewPDF from './PreviewPDF/PreviewPDF';

import classes from './ShowDegree.module.css';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ShowDegree = props => {
  const [dialog, setDialog] = useState(props.open);

  const closeDialog = () => {
    setDialog(false);
    props.closeDegree();
  };

  const downloadPDFHandler = (urlDegree, course) => () => {
    const link = document.createElement('a');
    link.href = urlDegree;
    link.setAttribute('download', `${course}.pdf`);
    document.body.appendChild(link);
    link.click();
  };

  return (
    <Dialog
      open={dialog}
      TransitionComponent={Transition}
      onClose={closeDialog}
      fullScreen
    >
      <div className={classes.header}>
        <p className={classes.degreeTitle}>Vista del Diploma</p>
        <div className={classes.optionsContainer}>
          <IconButton
            className={classes.itemBtn}
            color="inherit"
            onClick={downloadPDFHandler(
              props.urlDegree,
              props.courseDegree
            )}
          >
            <CloudDownloadIcon />
          </IconButton>
          <Share
            urlDegree={props.urlDegree}
            courseDegree={props.courseDegree}
            endDate={props.endDate}
          />
          <IconButton
            className={classes.itemBtn}
            color="inherit"
            onClick={closeDialog}
            aria-label="Close"
          >
            <CloseIcon />
          </IconButton>
        </div>
      </div>
      <PreviewPDF
        urlDegree={props.urlDegree}
        courseDegree={props.courseDegree}
      />
    </Dialog>
  );
};

ShowDegree.propTypes = {
  // eslint-disable-next-line react/require-default-props
  open: PropTypes.bool,
  // eslint-disable-next-line react/require-default-props
  closeDegree: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  urlDegree: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  courseDegree: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  endDate: PropTypes.number
};

export default ShowDegree;
